import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BcModalComponent } from '@bancolombia/design-system-web/bc-modal';

@Component({
  selector: 'app-modal-actu-datos',
  templateUrl: './modal-actu-datos.component.html',
  styleUrls: ['./modal-actu-datos.component.scss']
})
export class ModalActuDatosComponent {

  
  @ViewChild("modalConf", { static: false }) modalAll?: BcModalComponent;
  @Input() ejecutarModal : boolean = false;
  @Output() ejecuChange = new EventEmitter<boolean>();

    ngOnChanges(changes: SimpleChanges): void {
      if(this.ejecutarModal && changes.ejecutarModal){
        if (changes.ejecutarModal.currentValue) {
          this.abrirModal();
        }
      }

    }

  abrirModal() {
    this.modalAll.openModal();
  }

  onPressButton(event :0|1){
    if(event===1) {
      this.modalAll.shutDown();
      this.ejecuChange.emit(this.ejecutarModal);
    }
  }

  cerrarModal(){
    this.ejecuChange.emit(this.ejecutarModal);
  }

}
